import React from "react";
import ServiceList from "./ServiceList";
import "./ServiceCard.css";
export const LocHeader = (props) => {
    return (
        <div className="loccontainer">

            {/* LEFT SIDEBAR */}
            <div className="sidebar">

                <div className="sidebar-header">
                    <div className="sidebar-header-top">
                        <div className="sidebar-header-bar"></div>

                        <h1 className="sidebar-title">
                            RO Service in Patna @9311587744
                        </h1>
                    </div>

                    <div className="sidebar-subtitle">
                        <span>Premium Service Package</span>
                    </div>
                </div>


                <div className="sidebar-card">

                    <div className="sidebar-header">
                        <div className="sidebar-header-content">

                            <div className="calendar-icon-box">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="calendar-icon"
                                >
                                    <path d="M8 2v4"></path>
                                    <path d="M16 2v4"></path>
                                    <rect
                                        width="18"
                                        height="18"
                                        x="3"
                                        y="4"
                                        rx="2"
                                    ></rect>
                                    <path d="M3 10h18"></path>
                                </svg>
                            </div>

                            <div>
                                <p className="sidebar-title">
                                    Select Product
                                </p>

                                <p className="sidebar-subtitle">
                                    Choose a product to view details
                                </p>
                            </div>

                        </div>
                    </div>


                    <div className="sidebar-body">

                        <div className="service-item-container">

                            <div className="service-grid">

                                {/* Repair */}
                                <div>
                                    <a
                                        className="service-item"
                                        href="#1"
                                    >
                                        <div className="service-item-img-container">
                                            <div className="service-item-img">

                                                <img
                                                    alt="Repair"
                                                    title="Repair"
                                                    loading="lazy"
                                                    width="64"
                                                    height="64"
                                                    src="/img/location/data-REPIR.avif"
                                                    className="service-item-image"
                                                />

                                            </div>
                                        </div>

                                        <p className="service-item-title">
                                            Repair
                                        </p>
                                    </a>
                                </div>


                                {/* Service */}
                                <div>
                                    <a
                                        className="service-item"
                                        href="#518"
                                    >
                                        <div className="service-item-img-container">
                                            <div className="service-item-img">

                                                <img
                                                    alt="Service"
                                                    title="Service"
                                                    loading="lazy"
                                                    width="64"
                                                    height="64"
                                                    src="/img/location/data-ROUTINE-SERVICE.avif"
                                                    className="service-item-image"
                                                />

                                            </div>
                                        </div>

                                        <p className="service-item-title">
                                            Service
                                        </p>
                                    </a>
                                </div>


                                {/* Installation */}
                                <div>
                                    <a
                                        className="service-item"
                                        href="#2"
                                    >
                                        <div className="service-item-img-container">
                                            <div className="service-item-img">

                                                <img
                                                    alt="Installation"
                                                    title="Installation"
                                                    loading="lazy"
                                                    width="64"
                                                    height="64"
                                                    src="/img/location/data-RO-INSTALLATION.avif"
                                                    className="service-item-image"
                                                />

                                            </div>
                                        </div>

                                        <p className="service-item-title">
                                            Installation
                                        </p>
                                    </a>
                                </div>


                                {/* Un-installation */}
                                <div>
                                    <a
                                        className="service-item"
                                        href="#3"
                                    >
                                        <div className="service-item-img-container">
                                            <div className="service-item-img">

                                                <img
                                                    alt="Un-installation"
                                                    title="Un-installation"
                                                    loading="lazy"
                                                    width="64"
                                                    height="64"
                                                    src="/img/location/data-RO-UNINSTALLATION.avif"
                                                    className="service-item-image"
                                                />

                                            </div>
                                        </div>

                                        <p className="service-item-title">
                                            Un-installation
                                        </p>
                                    </a>
                                </div>


                                {/* AMC */}
                                <div>
                                    <a
                                        className="service-item"
                                        href="#103"
                                    >
                                        <div className="service-item-img-container">
                                            <div className="service-item-img">

                                                <img
                                                    alt="AMC Plan 1"
                                                    title="AMC Plan 1"
                                                    loading="lazy"
                                                    width="64"
                                                    height="64"
                                                    src="/img/location/data-AMC.avif"
                                                    className="service-item-image"
                                                />

                                            </div>
                                        </div>

                                        <p className="service-item-title">
                                            AMC Plan 1
                                        </p>
                                    </a>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>


            {/* RIGHT CONTENT */}
            <div className="service-list-wrapper">

                <div className="banner">

                    <img
                        src="/img/banners/loc_servicebanner.avif"
                        alt="RO Water Purifier Service"
                        className="banner-img"
                    />

                </div>


                {/* Reusable Service Cards */}
                <ServiceList />

            </div>

        </div>
    );
};